<template>
  <v-container class="pa-0" fluid>

    <FilterGroup v-if="!hideProduct" :title="$t('servicesystem.common_objects.machine.product')"
      :applied-filters="[typesfilter, suppliersfilter, modelsfilter, onlyWithActiveContractFilter]" style="border-top: none;">
      <MachineTypeSelect v-if="!hideMachineTypeFilter" v-model="typesfilter" multiple clearable externaledit>
      </MachineTypeSelect>
      <SupplierSelect v-if="!hideSupplierFilter" v-model="suppliersfilter" multiple clearable externaledit class="my-3">
      </SupplierSelect>
      <ModelSelect v-model="modelsfilter" multiple clearable externaledit>
      </ModelSelect>
      <AssetTypeSelect v-if="assetTypesEnabled" v-model="assetTypesfilter" multiple clearable externaledit class="mt-3">
      </AssetTypeSelect>
      <v-row v-if="preventiveMaintenanceEnabled" no-gutters justify="start" align="center" class="mt-3">
        <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.machine.service_agreement") }}:</p>
        <QButtonGroup v-model="serviceagreementfilter" :list="serviceAgreementFilterOptions" :edit="true" dense noempty>
        </QButtonGroup>
      </v-row>
      <v-row no-gutters align="center" class="mt-3">
        <v-checkbox
          v-model="onlyWithActiveContractFilter"
          :label="$t('servicesystem.common_objects.machine.only_with_active_contract')"
          hide-details
          dense
        />
      </v-row>
    </FilterGroup>

    <FilterGroup v-if="!hideOwnership" :title="$t('servicesystem.common_objects.customer.ownership')"
      :applied-filters="[customerfilter]">
      <CustomerSelect v-model="customerfilter" clearable externaledit>
      </CustomerSelect>
      <!--
      <QAutoComplete v-model="parentcustomerfilter"
                     :label="$t('servicesystem.common_objects.customer.parent_org')"
                     :list="customerList"
                     :textkey="'Name'"
                     :valuekey="'Id'"
                     clearable
                     externaledit>
      </QAutoComplete>
      <QAutoComplete v-model="customergroupfilter"
                     :label="$t('servicesystem.common_objects.customer.group')"
                     :list="customerGroupList"
                     :textkey="'Name'"
                     :valuekey="'Id'"
                     clearable
                     externaledit>
      </QAutoComplete>
      -->
    </FilterGroup>

    <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
  </v-container>
</template>


<script>
//import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import FilterGroup from "@/components/FilterGroup.vue";
import AssetTypeSelect from "@/components/Inputs/EntityDropdowns/AssetTypeSelect2.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import ModelSelect from "@/components/Inputs/EntityDropdowns/MachineModelSelect2.vue";
import MachineTypeSelect from "@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";

export default {
  name: "MachineListFilterContent",
  props: {
    pk: String,
    hideProduct: Boolean,
    hideSupplierFilter: Boolean,      //-- hides supplier filter
    hideMachineTypeFilter: Boolean,   //-- hides machine type filter
    hideOwnership: Boolean,
  },
  components: {
    FilterGroup,
    CustomerSelect,
    ModelSelect,
    SupplierSelect,
    MachineTypeSelect,
    AssetTypeSelect,
    DefaultLifeCycleFilterGroup,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
      serviceAgreementFilterOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.yes") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.no") },
      ],
    };
  },

  methods: {},

  computed: {
    serviceagreementfilter: {
      get() { return this.getQueryParam("filter-serviceagreement", 0); },
      set(update) { this.setQueryParam("filter-serviceagreement", update); },
    },
    typesfilter: {
      get() { return this.getQueryParam("filter-types", []); },
      set(update) { this.setQueryParam("filter-types", update); },
    },
    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },
    modelsfilter: {
      get() { return this.getQueryParam("filter-models", []); },
      set(update) { this.setQueryParam("filter-models", update); },
    },
    assetTypesfilter: {
      get() { return this.getQueryParam("filter-asset-types", []); },
      set(update) { this.setQueryParam("filter-asset-types", update); },
    },
    customerfilter: {
      get() { return this.getQueryParam("filter-customer", ""); },
      set(update) { this.setQueryParam("filter-customer", update); },
    },
    onlyWithActiveContractFilter: {
      get() { return this.getQueryParam("filter-onlyactivecontract", false) === true || this.getQueryParam("filter-onlyactivecontract", "") === "1"; },
      set(update) { this.setQueryParam("filter-onlyactivecontract", update ? "1" : ""); },
    },
    /*
    parentcustomerfilter: {
      get() { return this.getQueryParam("filter-parentcustomer", ""); },
      set(update) { this.setQueryParam("filter-parentcustomer", update); },
    },
    customergroupfilter: {  
      get() {  return this.getQueryParam("filter-customergroup", ""); },
      set(update) { this.setQueryParam("filter-customergroup", update); },
    },
    */

    assetTypesEnabled() {
      return this.$store.state.GlobalSettings.Features.AssetTypesEnabled;
    },

    preventiveMaintenanceEnabled() {
      return this.$store.state.GlobalSettings.PreventiveMaintenanceEnabled;
    },
  },

  watch: {},
};
</script>
